export interface CampaignShimmerBlock {
  value?: string | null
}

export function CampaignShimmerBlock({ value }: CampaignShimmerBlock) {
  return (
    <div className='ml-[40px]'>
      <div className='loading-shimmer'>{value}</div>
    </div>
  )
}
